const platformUserManagement = () => import('./platformUserManagement');
const operationLog = () => import('./operationLog');
const schoolCertInfo = () => import('./schoolCertInfo/schoolCertInfo');
const teacherCertInfoManage = () =>
  import('./teacherCertInfoManage/teacherCertInfoManage');

const schoolInfoManagement = () =>
  import('./schoolInfoManagement/schoolInfoManagement');

const Router = [
  {
    path: 'platformUserManagement',
    name: 'platformUserManagement',
    component: platformUserManagement,
    meta: {
      title: '平台用户管理',
    },
  },
  {
    path: 'operationLog',
    name: 'operationLog',
    component: operationLog,
    meta: {
      title: '操作日志',
    },
  },
  {
    path: 'schoolCertInfo',
    name: 'schoolCertInfo',
    component: schoolCertInfo,
    meta: {
      title: '学校/组织认证信息',
    },
  },
  {
    path: 'teacherInfoManage_manage',
    name: 'teacherCertInfoManage',
    component: teacherCertInfoManage,
    meta: {
      title: '(平台)教师认证信息',
    },
  },
  {
    path: 'schoolInfoManagement',
    name: 'schoolInfoManagement',
    component: schoolInfoManagement,
    meta: {
      title: '学校/组织信息管理',
    },
  },
];
export default Router;
